import { useMemo, useState } from "react";
import DataTable from "../../../../components/dataTable/dataTable";
import { getEmployees } from "../../../../store/actions/employees.action";
// import { Loading } from "../../../../utils/helpers/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiOutlineSync } from "react-icons/ai";
import { BiPowerOff } from "react-icons/bi";
import { GiPadlock, GiPadlockOpen } from "react-icons/gi";
import { HiOutlineUserGroup } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { ReactComponent as Edit } from "../../../../assets/images/svgs/edit.svg";
import AddNewEmployeeModal from "../../../../components/modals/AddNewEmployeeModal";
import EditEmployeeModal from "../../../../components/modals/EditEmployeeModal";
import SuspendModal from "../../../../components/modals/SuspendModal";
import { employeeTableConfig } from "../../../../utils/helpers/dataTableConfigs";
import { EmployeeService } from "../../../../utils/services/employees.service";

const Body = ({ employees = [], info, currency, countries, domainBrand }) => {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [filterInput] = useState("");
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");
  const [employeeObject, setEmployeeObject] = useState({});
  const [type, setType] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newEmployee, setNewEmployee] = useState(false);
  const [role, setRole] = useState("");
  const [reset, setReset] = useState(false);

  const actionColumn = {
    Header: () => {
      return <span className="text-center">Action</span>;
    },
    columnId: 5,
    accessor: "actions",
    Cell: ({ row }) => {
      const status = row.original.status;
      return (
        <div className="text-center pointer">
          <OverlayTrigger
            key={"1"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Edit</Tooltip>}
          >
            <Edit
              onClick={() => {
                setShow(true);
                setId(row?.original?.userId);
                setEmployeeObject(row?.original);
              }}
            />
          </OverlayTrigger>
          &nbsp;
          {status === "DEACTIVATED" ? (
            <OverlayTrigger
              key={"2"}
              placement={"bottom"}
              overlay={<Tooltip id={`tooltip-${``}`}>Activate</Tooltip>}
            >
              <GiPadlockOpen
                color={"#6259CA"}
                fontSize={20}
                fill={"#6259CA"}
                onClick={() => {
                  setType("ACTIVATE-EMPLOYEE");
                  setId(row?.original?.userId);
                  setOpen(true);
                  setEmployeeObject(row?.original);
                }}
              />
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              key={"2"}
              placement={"bottom"}
              overlay={<Tooltip id={`tooltip-${``}`}>Deactivate</Tooltip>}
            >
              <GiPadlock
                color={"#6259CA"}
                fontSize={20}
                fill={"#6259CA"}
                onClick={() => {
                  setType("SUSPEND-EMPLOYEE");
                  setId(row?.original?.userId);
                  setOpen(true);
                  setEmployeeObject(row?.original);
                }}
              />
            </OverlayTrigger>
          )}
          &nbsp;
          <OverlayTrigger
            key={"3"}
            placement={"bottom"}
            overlay={
              <Tooltip id={`tooltip-${``}`}>Allow duplicate login</Tooltip>
            }
          >
            <HiOutlineUserGroup
              color={"#6259CA"}
              fontSize={20}
              fill={"#6259CA"}
              onClick={() => {
                setType("DUPLICATE-LOGIN");
                setId(row?.original?.userId);
                setOpen(true);
                setEmployeeObject(row?.original);
              }}
            />
          </OverlayTrigger>
          &nbsp;
          <OverlayTrigger
            key={"4"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Disable OTP</Tooltip>}
          >
            <BiPowerOff
              color={"#6259CA"}
              fontSize={22}
              fill={"#6259CA"}
              onClick={() => {
                setType("DISABLE-OTP");
                setId(row?.original?.userId);
                setOpen(true);
                setEmployeeObject(row?.original);
              }}
            />
          </OverlayTrigger>
          &nbsp;
          <OverlayTrigger
            key={"5"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${``}`}>Password reset</Tooltip>}
          >
            <AiOutlineSync
              color={"#6259CA"}
              fontSize={20}
              fill={"#6259CA"}
              onClick={() => {
                setType("PASSWORD-RESET");
                setId(row?.original?.userId);
                setOpen(true);
                setEmployeeObject(row?.original);
                setReset(true);
              }}
              className={`${reset ? "reset-password-icon" : ""}`}
            />
          </OverlayTrigger>
          &nbsp;
        </div>
      );
    },
  };

  const tableObject = [...employeeTableConfig, actionColumn];
  const columns = useMemo(() => tableObject, []);
  // const handleFilterChange = (e) => setFilterInput(e.target.value);

  const handleDisableOtp = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.disableOtp(id);
      if (response.data.status === "SUCCESS") {
        toast.success("OTP disabled successfully");
        dispatch(getEmployees());
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handlePasswordReset = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.allowPasswordReset(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Password reset enabled successfully");
        dispatch(getEmployees());
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleSuspend = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.suspendEmployee(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Employee deactivated successfully");
        dispatch(getEmployees());
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleDuplicateLogin = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.allowDuplicateLogin(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Duplicate login successfully enabled.");
        dispatch(getEmployees());
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  const handleUnsuspend = async (id) => {
    setLoading(true);
    try {
      const response = await EmployeeService.activateEmployee(id);
      if (response.data.status === "SUCCESS") {
        toast.success("Employee activated successfully");
        dispatch(getEmployees());
      } else {
        toast.error(response.data.message);
      }
      setLoading(false);
      setOpen(false);
    } catch (error) {
      setLoading(false);
      setOpen(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <SuspendModal
        type={type}
        handleSuspend={() => handleSuspend(id)}
        handleUnsuspend={() => handleUnsuspend(id)}
        handleDisableOtp={() => handleDisableOtp(id)}
        handlePasswordReset={() => handlePasswordReset(id)}
        handleDuplicateLogin={() => handleDuplicateLogin(id)}
        show={open}
        handleClose={() => [setOpen(false)]}
        employee={{
          firstName:
            employeeObject?.firstName !== undefined
              ? employeeObject?.firstName
              : "",
          lastName:
            employeeObject?.lastName !== undefined
              ? employeeObject?.lastName
              : "",
        }}
        loading={loading}
      />
      <EditEmployeeModal
        show={show}
        handleClose={() => setShow(false)}
        countries={countries?.countries}
        domainBrand={domainBrand}
        employeeObject={employeeObject}
      />
      <AddNewEmployeeModal
        show={newEmployee}
        handleClose={() => setNewEmployee(false)}
        domainBrand={domainBrand}
        countries={countries}
        loading={loading}
        type={role}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary
                  ? dictionary["WO_EMPLOYEE_-1048133672"]
                  : "Employees"}
              </h1>
            </div>
            <div className="ms-auto pageheader-btn">
              <button
                onClick={() => {
                  setNewEmployee(true);
                  setRole("");
                }}
                className="btn btn-primary btn-icon text-white me-2"
              >
                <span>
                  <i className="fa fa-folder-plus" />
                </span>{" "}
                &nbsp;
                {dictionary
                  ? dictionary["WO_ADD_NEW_EMPLOYE_-831459411"]
                  : "ADD NEW EMPLOYEE"}
              </button>
            </div>
          </div>

          <>
            <div className="row row-sm">
              <div className="col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <DataTable
                        columns={columns}
                        data={employees}
                        filterData={filterInput}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Body;
